import { styled } from '@mui/material';
import { DataGridPro, gridClasses } from '@mui/x-data-grid-pro';

export const DataGridProStyled = styled(DataGridPro)(({ theme }) => ({
  [`&.${gridClasses.root}`]: {
    borderWidth: 0,
  },
  [`& .${gridClasses.columnHeaderTitle}, & .${gridClasses.columnHeaderTitleContainer}`]: {
    ...theme.typography.subtitle2,
  },
  [`& .${gridClasses.columnHeader}:focus-within, & .${gridClasses.cell}:focus-within`]: {
    outline: 'none',
  },
  [`& .${gridClasses.columnHeader}:focus, & .${gridClasses.cell}:focus`]: {
    outline: 'none',
  },
})) as typeof DataGridPro;
